export function unique< T, K >( array: T[], keyExtractor: ( item: T ) => K ): T[] {
	const seenKeys = new Set< K >()

	return array.filter( ( item ) => {
		const key = keyExtractor( item )
		if ( seenKeys.has( key ) ) {
			return false
		} else {
			seenKeys.add( key )
			return true
		}
	} )
}
